import { render, staticRenderFns } from "./subHeader.vue?vue&type=template&id=85c7869c"
import script from "./subHeader.vue?vue&type=script&lang=js"
export * from "./subHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/subHeader.vue
// module id = null
// module chunks = 